// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2VcXr","inner":"Footer_inner__1AWUI"};